<template>
  <div class="col-1 scroll">
    <a href="javascript:void(0);" class="follow_drawer_btn m-a-10" @click="openList">人才列表查看</a>
    <el-table :data="list" class="col-1" border size="mini" tooltip-effect="dark" highlight-current-row>
      <el-table-column label="操作" align="center" width="40">
        <template slot-scope="scope">
          <el-dropdown trigger="click">
            <a href="javascript:void(0);"> <i class="el-icon-setting" /> </a>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="joinProject(scope.row)">加入项目</el-dropdown-item>
              <el-dropdown-item @click.native="recomend(scope.row)">推荐</el-dropdown-item>
              <el-dropdown-item @click.native="uploadCv(scope.row)">上传简历</el-dropdown-item>
              <el-dropdown-item @click.native="uploadReport(scope.row)">上传推荐报告</el-dropdown-item>
              <el-dropdown-item @click.native="genReport(scope.row)">生成推荐报告</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
      <el-table-column label="姓名" width="60">
        <template slot-scope="scope">
          <a href="javascript:void(0);" @click="showRadish(scope.row.rid || scope.row._id)">{{ scope.row['姓名'] }}</a>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="公司" sortable width="100">
        <template slot-scope="scope">{{ scope.row['公司'] }}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="手机" sortable width="80">
        <template slot-scope="scope">{{ scope.row['手机'] }}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="职能模块" sortable width="100">
        <template slot-scope="scope">{{ scope.row['职能模块'] && scope.row['职能模块'].toString() }}</template>
      </el-table-column>
      <el-table-column v-if="handleRemove" label="删" align="center" width="40">
        <template slot-scope="scope">
          <a href="javascript:void(0);" class="ft-danger" @click="handleRemove(scope.row)">
            <i class="el-icon-delete" />
          </a>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    list: { type: Array, default: () => [] },
    handleRemove: { type: Function, default: undefined },
  },
  computed: {
    radishList() {
      return window.app.root.$refs.main.$refs.radishList
    },
    radishDetailTab() {
      return app.root.$refs.radishDetailTab
    },
  },
  methods: {
    showRadish(id) {
      window.open(`${window.frontend}/#/radish-detail-blank/${id}`, '_blank')
    },
    openList() {
      const { list } = this
      if (list.length === 0) {
        this.$message('无内容')
        return
      }
      try {
        const ids = list.map(v => {
          if (v.rid) return v.rid
          if (v._id) return v._id
        })
        this.radishList.query = {
          _id: ids,
        }
        this.radishList.loadData()
      } catch (error) {
        console.error(error)
      }
      this.collapsed = true
    },
    joinProject(row) {
      this.radishList.currentRow = row
      this.radishList.showIntoProject(false)
    },
    recomend(row) {
      this.radishList.currentRow = row
      this.radishList.showRecommend(false)
    },
    uploadCv(row) {
      this.radishList.currentRow = row
      this.radishList.uploadCv()
    },
    uploadReport(row) {
      this.radishList.currentRow = row
      this.radishList.uploadReport()
    },
    genReport(row) {
      app.root.$refs.reportMaker.init({ radish: row.rid || row._id })
    },
  },
}
</script>
